import React, { useEffect, useState } from "react";
import "./InsuranceCard.css";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { fonts, themes } from "../../themes/themes";

interface contentTileType {
  tile_value: string;
  subtitle1: string;
  IdentifierNo: any;
  Issuetitle: string;
  IssueDate: any;
  ExpDate: any;
  Expirytitle: string;
  onDelete?: any;
  onView?: any;
}
const InsuranceCard: React.FC<contentTileType> = ({
  tile_value,
  subtitle1,
  IdentifierNo,
  Issuetitle,
  IssueDate,
  Expirytitle,
  ExpDate,
  onDelete,
  onView,
}) => {
  return (
    <Grid container className="action-tileContainer">
      <Grid item style={{ flexGrow: 1 }}>
        <Typography
          className="title1"
          sx={{ fontSize: "0.95em", fontWeight: "bold" }}
        >
          {tile_value}
        </Typography>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: "0.75em" }}>
              {subtitle1}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: "0.75em",
                fontWeight: "bold",
              }}
            >
              {IdentifierNo}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item style={{ marginTop: "0.09em" }}>
            <Typography className="Issuetitle" sx={{ fontSize: "0.75em" }}>
              {Issuetitle}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="IssueDate"
              sx={{
                fontSize: "0.875em",
                marginLeft: "0.2em",
                fontWeight: "bold",
              }}
            >
              {IssueDate}
            </Typography>
          </Grid>
          <Grid item>
            <Divider orientation="vertical" sx={{ marginLeft: "0.5em" }} />
          </Grid>
          <Grid item style={{ marginTop: "0.1em" }}>
            <Typography
              className="Issuetitle"
              sx={{
                color: themes.red,
                marginLeft: "0.5em",
                fontSize: "0.75em",
              }}
            >
              {Expirytitle}:
            </Typography>
          </Grid>
          <Grid item style={{ marginTop: "0.07em" }}>
            <Typography
              className="expdate"
              sx={{
                color: themes.red,
                fontSize: "0.875em",
                marginLeft: "0.2em",
                fontWeight: "bold",
              }}
            >
              {ExpDate}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ marginTop: "1.5em", marginLeft: "0.5em" }}>
        <Box
          style={{
            border: "1px solid #E6E8EF",
            color: "#FF5263",
            width: "1.8125em",
            height: "1.8125em",
            alignItems: "flex-end",
            justifyContent: "center",
            display: "flex",
            borderRadius: "0.375em",
            cursor: "pointer",
          }}
          onClick={onDelete}
        >
          <i className="las la-trash-alt"></i>
        </Box>
      </Grid>
      <Grid item style={{ marginTop: "1.5em", marginLeft: "0.5em" }}>
        <Box
          style={{
            border: "1px solid #E6E8EF",
            color: "#7C0E6F",
            width: "1.8125em",
            height: "1.8125em",
            alignItems: "flex-end",
            justifyContent: "center",
            display: "flex",
            borderRadius: "0.375em",
            cursor: "pointer",
          }}
          onClick={onView}
        >
          <i className="lar la-eye"></i>
        </Box>
      </Grid>
    </Grid>
  );
};

export default InsuranceCard;
